import React from 'react';
import classNames from 'classnames';
import { func, string } from 'prop-types';
import Button from '@alltrails/shared/denali/components/Button';
import EmptyStateBase from '@alltrails/shared/components/EmptyStateBase';
import * as styles from './styles/styles.module.scss';

const SearchEmptyState = ({ option, srcIcon, alt, title, subText, btnText, handlePrimaryCtaClick }) => {
  return (
    <EmptyStateBase
      className={styles.container}
      icon={<img src={srcIcon} alt={alt} />}
      title={title}
      subText={subText}
      cta={
        btnText ? (
          <Button
            text={btnText}
            className={classNames({ [styles.primaryCta]: option !== 'completed', [styles.primaryHidden]: option === 'completed' })}
            onClick={() => handlePrimaryCtaClick(option)}
            testId={btnText}
            variant="primary"
          />
        ) : null
      }
    />
  );
};

SearchEmptyState.propTypes = {
  option: string,
  srcIcon: string,
  alt: string,
  title: string,
  subText: string,
  btnText: string,
  handlePrimaryCtaClick: func
};

SearchEmptyState.defaultProps = {
  option: '',
  srcIcon: '',
  alt: '',
  title: '',
  subText: '',
  btnText: '',
  handlePrimaryCtaClick: null
};

export default SearchEmptyState;
